export const EMPLOYEE_CLIENT_PREFERENCE_STATUS = {
  BLOCKED: 1,
  PREFERRED: 0
};

export const EMPLOYEE_FIELD_BIRTHDAY = 1;
export const EMPLOYEE_FIELD_START_EMPLOYMENT_DATE = 2;
export const EMPLOYEE_FIELD_LEVEL = 91373;
